import { Button as _Button } from "./button";
import { ButtonContent } from "./button-content";
import { ButtonIcon } from "./button-icon";

const Button = _Button as typeof _Button & {
    Content: typeof ButtonContent;
    Icon: typeof ButtonIcon;
};

Button.Content = ButtonContent;
Button.Icon = ButtonIcon;

export { Button };
export type { ButtonProps } from "./button";
export type { ButtonContentProps } from "./button-content";
export type { ButtonIconProps } from "./button-icon";
